import { jsx as _jsx } from "react/jsx-runtime";
import { observer } from 'mobx-react';
import { CopyToClipboardButton as CopyToClipboardButtonPrimitive, } from '@marvelapp/ballpark-components';
export const CopyToClipboardButton = observer(function CopyToClipboardButton(props) {
    return (_jsx(CopyToClipboardButtonPrimitive, Object.assign({ className: "absolute right-2 top-2 hidden group-hover/cell:flex", size: "sm" }, props)));
});
